import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useScheduleContext } from 'containers/pages/CANguard/context/ScheduleProvider';
import { GuardTabs } from 'pages/CANguard/CANguard';
import ScheduleRow from './ScheduleRow';
import { useGuardRoleContext } from 'containers/pages/CANguard/context/GuardRoleProvider';

interface ScheduleTabProps {
	goToTab: (tab: GuardTabs) => void;
}

const ScheduleTab: React.FC<ScheduleTabProps> = (props) => {
	// Implement the logic for the ScheduleTab component here
	const { schedule } = useScheduleContext();
	const { isAdmin } = useGuardRoleContext();

	if (schedule.length === 0) {
		return (
			<Paper elevation={1} sx={{ p: 4, m: 2, textAlign: 'center' }}>
				<Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
					<Typography variant="h6" color="text.secondary">
						No patrols scheduled
					</Typography>
					<Typography variant="body2" color="text.secondary">
						There are no patrols scheduled for the selected date. Please check back later or select a different date.
					</Typography>
				</Box>
			</Paper>
		);
	}

	return (
		<>
			<TableContainer component={Paper}>
				<Table sx={{ minWidth: { xs: 'auto', md: 650 } }}>
					<TableHead>
						<TableRow>
							<TableCell align="left" sx={{ width: '1%' }} />
							<TableCell align="left">ID</TableCell>
							{isAdmin && (
								<TableCell align="left">DDS Uploads</TableCell>
							)}
							<TableCell align="left">Customer</TableCell>
							<TableCell align="left">Address</TableCell>
							<TableCell align="left">Time</TableCell>
							<TableCell align="left">Status</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{schedule.map((row, index) => (
							<ScheduleRow
								key={row.schedule_assignment_id}
								row={row}
								goToTab={props.goToTab}
								index={index}
							/>
						))}
					</TableBody>
				</Table>
			</TableContainer>
		</>
	);
};

export default ScheduleTab;
